<template>
  <div class="d-flex">
    <basic-input-modal
      @selectedElement="propagateChange"
      :byDefault="getData()"
      :student="studentName"
      :title="title"
      ref="input"
      :options="items"/>
  </div>
</template>
<script>
import BabyStatusFace from './BabyStatusFace.vue'
import BasicInputModal from './BasicInputModal.vue'
import {componentValues, getDataByValue} from '@/utils/componentsValue'

export default {
  components: { BabyStatusFace, BasicInputModal },
  created: function () {
    this.state = this.$attrs.student ? this.$attrs.student.firstCourseType : this.byDefault
  },
  props: {
    title: {
      type: String,
      default: () => 'Primer Plato'
    },
    studentName: String
  },
  data: () => ({
    enabled: false,
    byDefault: 'PURE',
    state: '',
    items: componentValues.firstCourseType
  }),
  methods: {
    getData: function () {
      return getDataByValue(this.items, this.state)
    },
    setValue: function (value) {
      this.state = value
      this.$refs.input.setValue(this.getData())
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.input.setEnable(value)
    },
    propagateChange: function ({item}) {
      this.$emit('updatedElement',
        { firstCourseType: item.value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/FirstCourseType.vue